import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8dfa352a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  class: "navigation-tabs"
};
const _hoisted_3 = {
  class: "top-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_seller_filter = _resolveComponent("seller-filter");
  const _component_marketplace_filter = _resolveComponent("marketplace-filter");
  const _component_empty_segments = _resolveComponent("empty-segments");
  const _component_segment_filter = _resolveComponent("segment-filter");
  const _component_product_filter = _resolveComponent("product-filter");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_navigation_tabs, {
    tabs: $options.computedTabs,
    modelValue: $options.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event)
  }, null, 8, ["tabs", "modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_seller_filter, {
    sellers: _ctx.sellers_filter,
    onlyMode: true,
    onApply: $options.applySellers,
    onCleared: $options.clearSellers
  }, null, 8, ["sellers", "onApply", "onCleared"]), _createVNode(_component_marketplace_filter, {
    marketplaces: _ctx.marketplaces_filter,
    onlyMode: true,
    onApply: $options.applyMarketplaces,
    onCleared: _ctx.clearMarketplaces
  }, null, 8, ["marketplaces", "onApply", "onCleared"]), _createVNode(_component_segment_filter, {
    segments: _ctx.segments_filter,
    sellers: _ctx.sellers_filter,
    onApply: $options.applySegments
  }, {
    empty: _withCtx(() => [_createVNode(_component_empty_segments)]),
    _: 1
  }, 8, ["segments", "sellers", "onApply"]), _createVNode(_component_product_filter, {
    products: _ctx.products_filter,
    sellers: _ctx.sellers_filter,
    marketplaces: _ctx.marketplaces_filter,
    onlyMode: true,
    onApply: $options.applyProducts,
    onCleared: $options.handleProductsCleared
  }, null, 8, ["products", "sellers", "marketplaces", "onApply", "onCleared"]), _createVNode(_component_app_button, {
    variant: "text",
    version: "small",
    v2: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_app_icon, {
      icon: "info-circle"
    })]),
    _: 1
  })])]);
}